import Swal from "sweetalert2";
import { API_BASE } from "../../config/env";
import axios from "axios";
export const FETCH_LOGIN_FULFILLED = "FETCH_LOGIN_FULFILLED";
export const FETCH_LOGIN_REJECTED = "FETCH_LOGIN_REJECTED";
export const FETCH_LOGIN_PENDING = "FETCH_LOGIN_PENDING";
export const RESET_LOGIN = "RESET_LOGIN";
export const LOGOUT = "LOGOUT";
export const FETCH_TFA_PENDING = "FETCH_TFA_PENDING";
export const FETCH_TFA_FULFILLED = "FETCH_TFA_FULFILLED";
export const FETCH_TFA_REJECTED = "FETCH_TFA_REJECTED";

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

export function login(nationalIdentifier, password, setIsTfaModalOpen) {
  localStorage.setItem("One-Id", uuidv4());
  localStorage.setItem("Client-Id", uuidv4());

  return async (dispatch) => {
    dispatch({ type: FETCH_LOGIN_PENDING });

    try {
      const response = await axios({
        method: "post",
        url: `${API_BASE}/api/v3/auth/login`,
        data: { nationalIdentifier, password },
        headers: {
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69920"
        }
      });

      const { result } = response.data;

      if (result.isTfaNeeded === true) {
        setIsTfaModalOpen(true);
      }

      dispatch({
        type: FETCH_LOGIN_FULFILLED,
        payload: result
      });

      // Store tokens only if TFA is not needed
      localStorage.setItem("accessToken", result.accessToken);
      localStorage.setItem("refreshToken", result.refreshToken);
    } catch (error) {
      const { response } = error;

      if (response?.status === 401) {
        Swal.fire({
          icon: "error",
          title: "GİRİŞ HATASI",
          text: "Kimlik bilgilerinizi kontrol ediniz",
          footer:
            '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      } else if (response?.status === 400) {
        Swal.fire({
          icon: "error",
          title: "GİRİŞ HATASI",
          text: response?.data.responseMessage,
          footer:
            '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      } else if (response?.status === 404) {
        Swal.fire({
          icon: "error",
          title: "GİRİŞ HATASI",
          text: "Kullanıcı bulunamadı.",
          footer:
            '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      } else if (response?.status === 500) {
        Swal.fire({
          icon: "error",
          title: "SUNUCU HATASI",
          text: "Sunucuda bir sorun oluştu. Lütfen daha sonra deneyin.",
          footer:
            '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      } else if (response?.status === 429) {
        Swal.fire({
          icon: "error",
          title: "Erişim Kısıtlandı",
          text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Lütfen destek ekibimizle iletişime geçin.",
          footer:
            '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      }
      
      dispatch({
        type: FETCH_LOGIN_REJECTED,
        payload: {
          status: response?.status || 0,
          message: response?.data.responseMessage || "Bir hata oluştu...",
          details: response?.data || {}
        }
      });
    }
  };
}

export function verifyTfa(nationalIdentifier, tfaCode) {
  localStorage.setItem("One-Id", uuidv4());
  localStorage.setItem("Client-Id", uuidv4());

  return async (dispatch) => {
    dispatch({ type: FETCH_TFA_PENDING });

    try {
      const response = await axios({
        method: "post",
        url: `${API_BASE}/api/v3/auth/verify-tfa`,
        data: { nationalIdentifier, tfaCode },
        headers: {
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69920"
        }
      });

      const { result } = response.data;

      dispatch({
        type: FETCH_TFA_FULFILLED,
        payload: result
      });

      localStorage.setItem("accessToken", result.accessToken);
      localStorage.setItem("refreshToken", result.refreshToken);
      localStorage.setItem("user", JSON.stringify(result.user));

      // 🔥 Burayı ekle: component tarafı için response dön
      return { success: true, payload: result };
    } catch (error) {
      const { response } = error;

      dispatch({
        type: FETCH_TFA_REJECTED,
        payload: {
          status: response?.status,
          message: response?.data?.responseMessage || "TFA doğrulama başarısız"
        }
      });

      if (response?.status === 429) {
        Swal.fire({
          icon: "error",
          title: "Erişim Kısıtlandı",
          text: "Çok fazla deneme yapıldı. Lütfen destek ile iletişime geçin.",
          footer: '<a href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
        });
      }

      return { success: false, error: response };
    }
  };
}


export function logOut() {
  sessionStorage.clear();
  localStorage.clear();

  return (dispatch) => {
    dispatch({
      type: "LOGOUT"
    });
  };
}

export function resetLogin() {
  return (dispatch) => {
    dispatch({
      type: "RESET_ADDBASKET"
    });
  };
}
